import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { style } from "style";
import AnalyticsPageView from "../AnalyticsPageView";

const TitlePageComponent = ({ title }) => {
  const titleMap = {
    PetroRio: "PRIO",
    clubecasa: "Club&Casa",
    ClubCasa: "Club&Casa Integra",
    Bein: "Beauty University",
    Cury: "Cobertura Cury",
    Feimi: "FEIMI - Moda Inverno",
    Foton: "Fóton",
    Bambuibio: "Bambuí Energia",
    Natuzzi: "N360 Academy",
    mestreconstrutor: "Mestre Construtor",
    "Serquip mg": "Serquip MG",
    "Cheirin Bao": "Cheirin Bão",
    "Funeraria Vida": "Funerária Vida",
    "Nacao Valquirias": "Nação Valquírias",
  };

  const defaultTitle = titleMap[style.names.nameApp] || style.names.nameApp;

  return (
    <>
      <Helmet>
        <title>{title ? `${title} - ${defaultTitle}` : defaultTitle}</title>
      </Helmet>
      <AnalyticsPageView title={title} />
    </>
  );
};

TitlePageComponent.propTypes = {
  title: PropTypes.string,
};

TitlePageComponent.defaultProps = {
  title: "",
};

export default TitlePageComponent;
